<script setup>
import HeadingTwo from '@/Components/HeadingTwo.vue'
import { CheckCircleIcon } from '@heroicons/vue/24/outline'

const benefits_employee = ['Daňové přiznání v PDF a XML', 'Přílohy a pokyny, kam a jaké dokumenty odeslat']

const benefits_osvc = [
    'Daňové přiznání v PDF a XML',
    'Přehledy pro sociální zabezpečení a zdravotní pojišťovnu',
    'Přílohy a pokyny, kam a jaké dokumenty odeslat',
]
</script>

<template>
    <section class="section--width">
        <HeadingTwo value="Co od nás obdržíte?" />

        <div class="card mt-4 sm:mt-8 lg:py-14">
            <div class="w-full flex-auto">
                <div class="grid gap-y-5 xl:grid-cols-2">
                    <ul
                        role="list"
                        class="flex flex-col space-y-3 text-base/7"
                    >
                        <li class="text-lg font-semibold tracking-wide text-black dark:text-white">Zaměstnanci</li>

                        <li
                            v-for="benefit in benefits_employee"
                            :key="benefit"
                            class="flex gap-x-3 text-black dark:text-white"
                        >
                            <CheckCircleIcon
                                class="size-6 flex-none text-cyan-500"
                                aria-hidden="true"
                            />

                            {{ benefit }}
                        </li>
                    </ul>

                    <ul
                        role="list"
                        class="flex flex-col space-y-3 text-base/7"
                    >
                        <li class="text-lg font-semibold tracking-wide text-black dark:text-white">OSVČ</li>

                        <li
                            v-for="benefit in benefits_osvc"
                            :key="benefit"
                            class="flex gap-x-3 text-black dark:text-white"
                        >
                            <CheckCircleIcon
                                class="size-6 flex-none text-cyan-500"
                                aria-hidden="true"
                            />

                            {{ benefit }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>
